import { render, staticRenderFns } from "./MainHolder.vue?vue&type=template&id=b30f0a14"
import script from "./MainHolder.vue?vue&type=script&lang=js"
export * from "./MainHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports